import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("footer"); // Use 'footer' namespace

  return (
    <footer className="bg-white py-10">
      <hr className="mt-8 mb-8 border-t-2 border-gray-300" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo Section */}
        <div className="flex flex-col items-center text-center">
          <img
            src="/assets/images/logos/Without_BG_BLACK.png"
            alt={t("logo.alt")}
            className="h-20 sm:h-24 mb-4 object-contain"
          />
          <p className="text-gray-600 mb-6 font-bold">
            {t("logo.description")}
          </p>

          {/* Social Links */}
          <div className="flex space-x-4 items-center justify-center text-xl">
            <a
              href="https://www.facebook.com/share/y6RmgbortC5Hzv5m/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <i className="fab fa-facebook" aria-hidden></i>
              <span className="sr-only">Facebook</span>
            </a>
            <a
              href="https://www.instagram.com/wellstarjewels/profilecard/?igsh=MWRsdGI1dWEwZDI4bA=="
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <i className="fab fa-instagram" aria-hidden></i>
              <span className="sr-only">Instagram</span>
            </a>
            <a
              href="http://www.linkedin.com/in/wellstar-jewels-351ba9339"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <i className="fab fa-linkedin" aria-hidden></i>
              <span className="sr-only">LinkedIn</span>
            </a>
            <a
              href="https://wa.me/+919426374716"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <i className="fab fa-whatsapp" aria-hidden></i>
              <span className="sr-only">WhatsApp</span>
            </a>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-left">
          {/* Company */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
              {t("sections.company")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/customization" className="text-sm sm:text-base">
                  {t("links.customization")}
                </a>
              </li>
              <li>
                <a href="/aboutus" className="text-sm sm:text-base">
                  {t("links.aboutUs")}
                </a>
              </li>
              <li>
                <a href="/whatwedo" className="text-sm sm:text-base">
                  {t("links.whatWeDo")}
                </a>
              </li>
            </ul>
          </div>
          {/* Support */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
              {t("sections.support")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/contactus" className="text-sm sm:text-base">
                  {t("links.contactUs")}
                </a>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div>
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-3 sm:mb-4">
              {t("sections.legal")}
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-sm sm:text-base">
                  {t("links.privacyPolicy")}
                </a>
              </li>
              <li>
                <a href="/cookies" className="text-sm sm:text-base">
                  {t("links.cookies")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 border-t border-gray-200 pt-8 text-center">
          <p className="text-sm text-gray-500">{t("copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
